import React, { useEffect, useState, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "components/Common/TableContainer";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Modal,
    ModalHeader,
    ModalBody,
    Label,
    FormFeedback,
    Input,
    Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import Select from "react-select";
import toast from "react-hot-toast";


//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { addNewSert, getClass, getSerts, updateSert } from "helpers/fakebackend_helper";

const TermsList = () => {

    //meta title
    document.title = "Terms List";


    const { state } = useLocation()

    const [contact, setContact] = useState();
    const [contacts, setContacts] = useState();

    // validation
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: (contact && contact.name1) || "",
            status : (contact && contact.status) || "",

        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please Enter Your Name"),
        }),
        onSubmit: values => {
            if (isEdit) {
                const updateUser = {
                    id: contact.id,
                    name1: values.name,
                    status: values.status
                };
                // update user
                // dispatch(onUpdateSert(updateUser));
                // setIsEdit(false);
                // validation.resetForm();
                updateFun(updateUser)
            } else {
                const newUser = {
                    parent_id: state?.id ?? null,
                    name1: values["name"],
                    name2: '',
                };
                // save new user
                // dispatch(onAddNewSert(newUser));
                // validation.resetForm();
                addFun(newUser)
            }
            // toggle();
        },
    });

    const validations = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: (contacts && contacts.name1) || "",
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please Enter Your Name"),
        }),
        onSubmit: values => {
            if (isEdit) {
                const updateUser = {
                    id: contacts.id,
                    name1: values.name,
                    status: values.status
                };
                // update user
                // dispatch(onUpdateSert(updateUser));
                // setIsEdit(false);
                // validation.resetForm();
                updateFun(updateUser)
            } else {
                const newUser = {
                    parent_id: state?.id ?? null,
                    name1: values["name"],
                };
                // save new user
                // dispatch(onAddNewSert(newUser));
                // validation.resetForm();
                addFun(newUser)
            }
            // toggle();
        },
    });


    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(true);
    const [isLoading, setLoading] = useState(false)



    const [list, setList] = useState([])

    const getView = () => {
        setLoading(true)
        getClass(state?.id).then((res) => {
            setContact(res?.[0]);
            setLoading(false)

        }).catch((err) => {
            console.log('err', err)
            setLoading(false)

        })
    }

    const getList = () => {
        setLoading(true)
        getSerts(state?.id).then((res) => {
            setList(res)
            setLoading(false)
        }).catch((err) => {
            console.log('err', err)
            setLoading(false)

        })
    }


    useEffect(() => {
        if (state?.id) {
            getView()
        }
        getList()
    }, []);

    const addFun = (payload) => {
        addNewSert(payload).then((res) => {
            if (res?.success) {
                validation.resetForm()
                validations.resetForm()
                getList()
                setModal(false)
                toast.success('Added Success')
            }
        }).catch((err) => {
            console.log('err', err)
        })
    }

    const updateFun = (payload) => {
        updateSert(payload).then((res) => {
            setIsEdit(false);
            if (res?.success) {
                validation.resetForm()
                validations.resetForm()
                getView()
                getList()
                setModal(false)
                toast.success('Updated Success')
            }
        }).catch((err) => {
            console.log('err', err)
        })
    }

    const getData = (item) => {
        setIsEdit(true)
        setContacts(item)
        setModal(true)
    }


    const toggle = () => {
        setModal(!modal);
    };


    //delete customer
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (users) => {
        setContacts(users.id);
        setDeleteModal(true);
    };

    const handleUserClicks = () => {
        setIsEdit(false);
        setContacts('')
        toggle();
    };

    const columns = useMemo(
        () => [
            {
                header: "SNO",
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cell, row) => {
                    console.log('cell', cell);

                    return (
                        <>
                            <h5 className='font-size-14 mb-1'>
                                {cell.row.index + 1}
                            </h5>
                        </>
                    )
                }
            },
            {
                header: 'Name',
                accessorKey: 'name1',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cell) => {
                    return (
                        <>
                            <h5 className='font-size-14 mb-1'>
                                <Link to='#' className='text-dark'>{cell.getValue()}</Link>
                            </h5>
                        </>
                    )
                }
            },
            // {
            //     header: 'Status',
            //     accessorKey: 'status',
            //     enableColumnFilter: false,
            //     enableSorting: true,
            //     cell: (cell) => {
            //         return (
            //             <div>
            //                 {
            //                     cell.getValue() ?
            //                         <button type="button" className="btn btn-success">Active</button>
            //                         :
            //                         <button type="button" className="btn btn-danger">Disable</button>
            //                 }

            //             </div>
            //         );
            //     },
            // },

            {
                header: 'Action',
                cell: (cellProps) => {
                    return (
                        <div className="d-flex gap-3">
                            <button
                                className=" border-0 bg-none text-primary"
                                onClick={() => getData(cellProps.row.original)}
                            >
                                <i className="mdi mdi-eye font-size-18" id="deletetooltip" />
                            </button>
                        </div>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>

            <div className="page-content">
                <Container fluid>

                    <Breadcrumbs title="MEDIUM" breadcrumbItem="TERMS LIST" />

                    <div className="card">
                        <div className="card-body">
                            <Form
                                onSubmit={e => {
                                    e.preventDefault();
                                    setIsEdit(true);
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row className="align-items-end">
                                    <Col md={5} className="">
                                        <div className="mb-3">
                                            <Label className="form-label">Name</Label>
                                            <Input
                                                name="name"
                                                type="text"
                                                placeholder="Insert Name"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.name || ""}
                                                invalid={
                                                    validation.touched.name &&
                                                        validation.errors.name
                                                        ? true
                                                        : false
                                                }
                                            />
                                            {validation.touched.name &&
                                                validation.errors.name ? (
                                                <FormFeedback type="invalid">
                                                    {validation.errors.name}
                                                </FormFeedback>
                                            ) : null}
                                        </div>
                                    </Col>

                                    <Col md="5">
                                        <div className="mb-3">
                                            <Label>Select Status</Label>
                                            <Select
                                                placeholder='Select Status'
                                                options={[{label:'Active', value:true}, {label:'Inactive', value:false}]}
                                                getOptionLabel={(e) => e.label}
                                                getOptionValue={(e) => e.value}
                                                value={[{label:'Active', value:true}, {label:'Inactive', value:false}].find(e => e.value==validation.getFieldProps('status').value)}
                                                onChange={(e) => { validation.setFieldValue('status', e?.value) }}
                                                className="select2-selection"
                                            />
                                        </div>
                                    </Col>

                                    <Col md={2} >
                                        <div className="text-end mb-3">
                                            <button
                                                type="submit"
                                                className="btn btn-success save-user w-100"
                                            >
                                                Update
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </div>
                    <Row>
                        {
                            isLoading ? <Spinners setLoading={setLoading} />
                                :
                                <Col lg="12">
                                    <Card>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={list || []}
                                                isGlobalFilter={true}
                                                isPagination={true}
                                                SearchPlaceholder="Search..."
                                                isAddButton={true}
                                                handleUserClick={handleUserClicks}
                                                buttonClass="btn btn-success btn-rounded waves-effect waves-light addContact-modal mb-2"
                                                buttonName="Add Term"
                                                tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                                pagination="pagination"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                        }

                        <Modal isOpen={modal} toggle={toggle}>
                            <ModalHeader toggle={toggle} tag="h4">
                                {!!isEdit ? "Edit Term" : "Add Term"}
                            </ModalHeader>
                            <ModalBody>
                                <Form
                                    onSubmit={e => {
                                        e.preventDefault();
                                        validations.handleSubmit();
                                        return false;
                                    }}
                                >
                                    <Row>
                                        <Col xs={12}>
                                            <div className="mb-3">
                                                <Label className="form-label">Name</Label>
                                                <Input
                                                    name="name"
                                                    type="text"
                                                    placeholder="Insert Name"
                                                    onChange={validations.handleChange}
                                                    onBlur={validations.handleBlur}
                                                    value={validations.values.name || ""}
                                                    invalid={
                                                        validations.touched.name &&
                                                            validations.errors.name
                                                            ? true
                                                            : false
                                                    }
                                                />
                                                {validations.touched.name &&
                                                    validations.errors.name ? (
                                                    <FormFeedback type="invalid">
                                                        {validations.errors.name}
                                                    </FormFeedback>
                                                ) : null}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <div className="text-end">
                                                <button
                                                    type="submit"
                                                    className="btn btn-success save-user"
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </ModalBody>
                        </Modal>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    );
};

export default withRouter(TermsList);
